import CustomerRecords                                                  from "../../../../domain/record/customer/CustomerRecords";
import { ACTION_TYPE, CustomerRecordsAction, SetCustomerRecordsAction } from "./CustomerRecordsAction";

const reduceCustomerRecords = (action: SetCustomerRecordsAction): CustomerRecords => action.customerRecords;

const customerRecordsReducer = (state: CustomerRecords = new CustomerRecords(), action: CustomerRecordsAction): CustomerRecords => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.SET_CUSTOMER_RECORDS:
      return reduceCustomerRecords(action as SetCustomerRecordsAction);
  }
};

export default customerRecordsReducer;
